import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateInspectionStatus } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateInspectionStatus(orderId?: string) {
  const queryClient = useQueryClient()
  const { accessToken } = useAuthStore()

  return useMutation({
    mutationFn: async ({
      inspectionId,
      status,
      notes,
      documentUrl,
    }: {
      inspectionId: string
      status: "PENDING" | "IN_PROGRESS" | "COMPLETED" | "REJECTED"
      notes?: string
      documentUrl?: string
    }) => {
      if (!accessToken) throw new Error("No token available")
      return updateInspectionStatus(inspectionId, { status, notes, documentUrl }, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-orders"] })
      if (orderId) {
        queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
      }
    },
    onError: (error: any) => {
      console.error("Failed to update inspection status:", error)
    },
  })
}
